/**
 * @generated SignedSource<<3c90602f336a4d722ee827e9ebc2f775>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedThinBrowseItemTrackingProvider_itemSearch$data = {
  readonly searchTerm: string | null;
  readonly " $fragmentType": "SbSharedThinBrowseItemTrackingProvider_itemSearch";
};
export type SbSharedThinBrowseItemTrackingProvider_itemSearch$key = {
  readonly " $data"?: SbSharedThinBrowseItemTrackingProvider_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedThinBrowseItemTrackingProvider_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedThinBrowseItemTrackingProvider_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "searchTerm",
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "0ef732bbf3be47ea1e0eb1f7e7e44d67";

export default node;
